import FinalInvoice from 'components/FinalInvoice';
import AppointmentSummary from 'components/AppointmentSummary';

import { SOCKET_UPDATE_STEPS } from 'modules/sockets/constants';
import { hasDocumentsToSign } from 'components/Signature/utils';

import { SelfServiceStep } from 'components/SelfServices/types';

import { SelfServiceAPISteps, SelfServiceSteps } from 'modules/selfServices/types/SelfServiceSteps';

import { isNotAnswered } from '../utils';
import { SIGNATURE as COMMON_SIGNATURE } from '../common';

export const SUMMARY: SelfServiceStep = {
  key: SelfServiceSteps.SUMMARY,
  apiKey: SelfServiceAPISteps.APPOINTMENT_SUMMARY,
  component: AppointmentSummary,
  title: {
    id: 'page.appointmentSummary.title',
    defaultMessage: 'Your appointment',
  },
  next: SelfServiceSteps.FINAL_INVOICE,
  data: {
    preventBrowserNavigation: true,
    isVisible: ({ status }) => isNotAnswered(status),
    socketUpdateFields: SOCKET_UPDATE_STEPS.SUMMARY,
  },
};

export const FINAL_INVOICE: SelfServiceStep = {
  key: SelfServiceSteps.FINAL_INVOICE,
  apiKey: SelfServiceAPISteps.FINAL_INVOICE,
  component: FinalInvoice,
  title: {
    id: 'page.finalInvoice.title',
    defaultMessage: 'Final invoice',
  },
  previous: SUMMARY.key,
  next: SelfServiceSteps.PARKING,
  data: {
    isVisible: ({ status, finalInvoice }) => isNotAnswered(status) && Boolean(finalInvoice),
    socketUpdateFields: SOCKET_UPDATE_STEPS.FINAL_INVOICE,
  },
};

export const SIGNATURE: SelfServiceStep = {
  ...COMMON_SIGNATURE,
  data: {
    ...COMMON_SIGNATURE.data,
    isFinalizeStep: true,
    isVisible: (selfService) => hasDocumentsToSign(selfService),
  },
};
